import gql from 'graphql-tag'
import Constants from "../../Constants/Constants";

export const SUBSCRIBE_PRODUCT_BY_ID = gql`
subscription ($id: uuid!){
  Products(where: {id: {_eq: $id}}){
    id
    productCategoryId
    name
    nameInGuj
    sku
    hsn
    gst
    productCode
    description
    lowStockThreshold
    cartonQty
    purchasePrice
    margin
    displayPrice
    mrp
    weight
    weightUnit
    dimWidth
    dimDepth
    dimHeight
    isActive
    tags
    createdBy
    updatedBy
    youtubeURL
    tiktokURL
    isIndianProduct
    visibleOutsideSurat
    minQtyOutsideSurat
    ProductCategory{ id name }
    WarehouseStock{
      id warehouseId productId totalQty reservedQty
      Warehouse{ id name }
    }
    Attachments{ id type path isDefault }
  }
}`
export const SUBSCRIBE_ALL_PRODUCTS_COUNT = gql`
subscription allProductsCount{
  allProductsCount: Products_aggregate(where: {isDeleted:{_eq: false}}){
     aggregate{  count}
  }
}`
export const SUBSCRIBE_ALL_PRODUCTS_BY_WAREHOUSE = gql`
subscription ($warehouseId:uuid,$productCategoryIds:[uuid!], $offset:Int!, $limit: Int!, $searchORExp: [Products_bool_exp], $orderBy: [Products_order_by!]){
  Products(offset: $offset, limit: $limit, order_by: $orderBy, where: {isDeleted:{_eq: false}, productCategoryId:{_in: $productCategoryIds}, _or: $searchORExp}){
    id
    name
    sku
    hsn
    gst
    displayPrice
    lowStockThreshold
    isActive
    ProductCategory{id name}
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
    WarehouseStock(where: {warehouseId: {_eq: $warehouseId}}) {
      id
      totalQty
      reservedQty
    }
  }
}`
export const SUBSCRIBE_WAREHOUSE_STOCK_BY_WAREHOUSE = gql`
subscription ($warehouseId:uuid, $productCategoryIds:[uuid!], $isIndianProduct:Boolean = null, $offset:Int!, $limit: Int!, $searchORExp: [WarehouseStock_bool_exp], $orderBy: [WarehouseStock_order_by!]){
  products: WarehouseStock(where: {_and:[ {warehouseId: {_eq: $warehouseId}}, {Product: {isDeleted:{_eq: false}}}, {Product: {isIndianProduct:{_eq: $isIndianProduct}}}, {_or: $searchORExp},
            {Product: {productCategoryId:{_in: $productCategoryIds}}}, ]},
            offset: $offset, limit: $limit, order_by: $orderBy){
    id
    totalQty
    reservedQty
    Product{
        id
        name
        sku
        displayPrice
        lowStockThreshold
        isActive
        ProductCategory{id name}
        Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
        WarehouseStock(order_by: {Warehouse: {name: asc}}) {id totalQty Warehouse{id name}} 
    }
  }
}`

export const SUBSCRIBE_PRODUCT_COUNT = gql`
subscription ($productCategoryIds:[uuid!], $isIndianProduct: Boolean = null, $searchORExp: [Products_bool_exp]){
  ProductCount: Products_aggregate(where: {isDeleted:{_eq: false}, isIndianProduct:{_eq: $isIndianProduct}, productCategoryId:{_in: $productCategoryIds}, _or: $searchORExp, }){
    aggregate{ count }
  }
}`

export const SUBSCRIBE_WAREHOUSE_LOWSTOCK_BY_WAREHOUSE = gql`
subscription ($statement: String!, $orderBy: WarehouseStock_order_by = {}, $warehouseId:uuid, $productCategoryIds:[uuid!], $isIndianProduct:Boolean=null, $offset:Int!, $limit: Int!, $searchORExp: [EmptyTable_bool_exp]){
    lowStock: custom_statement(args: {statement: $statement}, where: {WarehouseStock: { warehouseId: {_eq: $warehouseId}, Product: {isDeleted:{_eq: false}, isIndianProduct:{_eq: $isIndianProduct},
              productCategoryId:{_in: $productCategoryIds}} }, _or: $searchORExp },
              offset: $offset, limit: $limit, order_by: {WarehouseStock: $orderBy}){
        id
        WarehouseStock {
            id
            totalQty
            reservedQty
            Product {
                id
                name
                sku
                displayPrice
                lowStockThreshold
                isActive
                ProductCategory{id name}
                Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
                WarehouseStock(order_by: {Warehouse: {name: asc}}) {id totalQty Warehouse{id name}}
            }
        }
    }
}`

export const SUBSCRIBE_LOWSTOCK_PRODUCT_COUNT = gql`
subscription ($warehouseIdString:String!, $productCategoryIds:[uuid!], $isIndianProduct:Boolean=null, $searchORExp: [Products_bool_exp]){
  lowStockCount: low_stock_in_products_aggregate(args: {warehouseid: $warehouseIdString}, where: {isDeleted:{_eq: false}, isIndianProduct:{_eq: $isIndianProduct}, productCategoryId:{_in: $productCategoryIds}, _or: $searchORExp}){
    aggregate{
      count
    }
  }
}`
export const SUBSCRIBE_WAREHOUSE_OUTOFSTOCK_BY_WAREHOUSE = gql`
subscription ($warehouseId:uuid, $productCategoryIds:[uuid!], $isIndianProduct:Boolean=null, $offset:Int!, $limit: Int!, $searchORExp: [WarehouseStock_bool_exp], $orderBy: [WarehouseStock_order_by!]){
  outOfStock: WarehouseStock(where: {_and:[ {warehouseId: {_eq: $warehouseId}}, {totalQty: {_eq: "0"}}, {Product: {isDeleted:{_eq: false}}}, {Product: {isIndianProduct:{_eq: $isIndianProduct}}},
            {Product: {productCategoryId:{_in: $productCategoryIds}}},{_or: $searchORExp}]},
            offset: $offset, limit: $limit, order_by: $orderBy){
    id
    totalQty
    reservedQty
    stock_out_at
    Product{
        id
        name
        sku
        displayPrice
        lowStockThreshold
        isActive
        ProductCategory{id name}
        Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
        WarehouseStock(order_by: {Warehouse: {name: asc}}) {id totalQty Warehouse{id name}}
    }
  }
}
`

export const SUBSCRIBE_OUTOFSTOCK_PRODUCT_COUNT = gql`
subscription ($warehouseId:uuid, $productCategoryIds:[uuid!], $isIndianProduct:Boolean=null, $searchORExp: [Products_bool_exp]){
  outOfStockCount: Products_aggregate(where: {WarehouseStock: {warehouseId: {_eq: $warehouseId}, totalQty: {_eq: "0"}}, isDeleted:{_eq: false}, isIndianProduct:{_eq: $isIndianProduct},
                   productCategoryId:{_in: $productCategoryIds}, _or: $searchORExp}){
    aggregate{
      count
    }
  }
}`

export const SUBSCRIBE_TOP_10_PRODUCTS_BY_AMOUNT = gql`
subscription top10ProductsByAmount($startDate:timestamptz!, $endDate:timestamptz!, $warehouseStr:String!, $warehouseArr:[uuid!]){
  top10ProductsByAmount: top_products_by_amount(args: {startdate: $startDate, enddate: $endDate, warehouse: $warehouseStr}, limit:10) {
    id
    name
    sku
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
    OrderItems_aggregate(where: {_and: [{created_at: {_gte: $startDate}}, {created_at: {_lte: $endDate}}, {fromWarehouseId: {_in: $warehouseArr}},
                                        {Order: {statusId: {_eq: "${Constants.OrderStatuses.Delivered}"}}}]}){
      aggregate {sum {totalPrice qty}}
    }
  } 
}`
export const SUBSCRIBE_TOP_10_PRODUCTS_BY_QUANTITY = gql`
subscription top10ProductsByQuantity($startDate:timestamptz!, $endDate:timestamptz!, $warehouseStr:String!, $warehouseArr:uuid_comparison_exp){
  top10ProductsByQuantity: top_products_by_quantity(args: {startdate: $startDate, enddate: $endDate, warehouse: $warehouseStr}, limit:10) {
    id
    name
    sku
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
    WarehouseStock(where: {Warehouse: {isActive: {_eq: true}}}, order_by: {Warehouse: {name: asc}}) {id totalQty Warehouse{id name}}
    OrderItems_aggregate(where: {_and: [{Order: {delivered_at: {_gte: $startDate}}}, {Order: {delivered_at: {_lte: $endDate}}}, {fromWarehouseId: $warehouseArr},
                                        {Order: {statusId: {_eq: "${Constants.OrderStatuses.Delivered}"}}}]}){
      aggregate {sum {totalPrice qty}}
    }
  } 
}`
export const SUBSCRIBE_GROUPED_PRODUCTS = gql`
subscription groupedProducts($startDate:timestamptz!, $endDate:timestamptz!, $warehouseStr:String!, $warehouseArr:[uuid!]){
  groupedProducts: top_products_by_amount(args: {startdate: $startDate, enddate: $endDate, warehouse: $warehouseStr}) {
    id
    name
    sku
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
    OrderItems_aggregate(where: {_and: [{created_at: {_gte: $startDate}}, {created_at: {_lte: $endDate}}, {fromWarehouseId: {_in: $warehouseArr}},
                                        {Order: {statusId: {_eq: "${Constants.OrderStatuses.Delivered}"}}}]}){
      aggregate { sum {totalPrice qty} count(distinct: true, columns: toCustomerId) }
    }
  } 
}`
export const SUBSCRIBE_LOW_STOCK_COUNT = gql`
subscription lowStockCount($warehouseId:String!){
 lowStockCount: low_stock_in_dashboard_aggregate(args: {warehouseid: $warehouseId}) {
    aggregate{count}
  }
}`

export const SUBSCRIBE_LOW_STOCK_PRODUCTS = gql`
subscription lowStockProducts($warehouseId:String!){
 lowStockProducts: low_stock_in_dashboard(args: {warehouseid: $warehouseId}) {
    id
    totalQty
    reservedQty
    stock_out_at
    Product { id name sku displayPrice lowStockThreshold isActive
              ProductCategory{id name} Attachments(order_by: {type: asc, isDefault: desc}) {id path type} }
    Warehouse {id name }         
  }
}`

export const SUBSCRIBE_NO_SOLD_PRODUCTS = gql`
subscription no_sold_products($statement: String = "", $aggregate: String = "", $warehouseId: uuid!, $offset:Int!, $limit: Int!) {
  products: custom_statement_products(args: {statement: $statement, aggregate: $aggregate}, offset: $offset, limit: $limit) {
    id
    name
    sku
    displayPrice
    lowStockThreshold
    isActive
    ProductCategory{id name}
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}
    WarehouseStock(where: {warehouseId: {_eq: $warehouseId}}) {
      id
      totalQty
      reservedQty
    }
  }
}
`
export const SUBSCRIBE_NO_SOLD_PRODUCTS_COUNT = gql`
subscription no_sold_products($statement: String = "", $aggregate: String = "") {
  productCount: custom_statement_products_aggregate(args: {statement: $statement, aggregate: $aggregate}) {
    aggregate { count }
  }
}
`
export const SUBSCRIBE_PURCHASE_RECENT_PRODUCTS = gql`
subscription purchase_recent_products($statement: String = "", $aggregate: String = "", $offset:Int!, $limit: Int!) {
  products: custom_statement_products(args: {statement: $statement, aggregate: $aggregate}, offset: $offset, limit: $limit) {
    id
    name
    sku
    purchasePrice 
    margin
    displayPrice
    aggregate
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}    
  }
}
`
export const SUBSCRIBE_PURCHASE_RECENT_PRODUCTS_COUNT = gql`
subscription purchase_recent_products_count($statement: String = "", $aggregate: String = "") {
  productCount: custom_statement_products(args: {statement: $statement, aggregate: $aggregate}, limit:1) {
    id    
    aggregate
  }
}
`
export const SUBSCRIBE_PURCHASE_ALL_PRODUCTS = gql`
subscription purchase_all_products($statement: String = "", $aggregate: String = "", $offset:Int!, $limit: Int!) {
  products: custom_statement_products(args: {statement: $statement, aggregate: $aggregate},
                   offset: $offset, limit: $limit) {
    id
    name
    sku
    purchasePrice 
    margin
    displayPrice
    aggregate
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}    
  }
}
`
export const SUBSCRIBE_PURCHASE_ALL_PRODUCTS_COUNT = gql`
subscription purchase_all_products_count($statement: String = "", $aggregate: String = "") {
  productCount: custom_statement_products(args: {statement: $statement, aggregate: $aggregate}, limit:1) {
    id    
    aggregate        
  }
}
`
export const SUBSCRIBE_PURCHASE_NEW_PRODUCTS = gql`
subscription purchase_new_products($statement: String = "", $aggregate: String = "", $offset:Int!, $limit: Int!) {
  products: custom_statement_products(args: {statement: $statement, aggregate: $aggregate},
                   offset: $offset, limit: $limit) {
    id
    name
    sku
    purchasePrice 
    margin
    displayPrice
    aggregate
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}    
  }
}
`
export const SUBSCRIBE_PURCHASE_NEW_PRODUCTS_COUNT = gql`
subscription purchase_new_products_count($statement: String = "", $aggregate: String = "") {
  productCount: custom_statement_products(args: {statement: $statement, aggregate: $aggregate}, limit:1) {
    id    
    aggregate        
  }
}
`

export const SUBSCRIBE_PURCHASE_REQUEST_PRODUCTS = gql`
subscription purchase_request_products($statement: String = "", $aggregate: String = "", $offset:Int!, $limit: Int!) {
  prProducts: custom_statement_products(args: {statement: $statement, aggregate: $aggregate},
                   offset: $offset, limit: $limit) {
    id
    name    
    sku
    aggregate
    Attachments(order_by: {type: asc, isDefault: desc}) {id path type}    
  }
}
`
export const SUBSCRIBE_PURCHASE_REQUEST_PRODUCTS_COUNT = gql`
subscription purchase_request_products_count($statement: String = "", $aggregate: String = "") {
  prProductCount: custom_statement_products_aggregate(args: {statement: $statement, aggregate: $aggregate}) {
    aggregate { count }
  }
}
`